import React, {PureComponent} from 'react';
import Helmet from 'react-helmet';
import {withRouter} from 'react-router-dom';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle} from '../../components/ImageHeader/ImageHeader.jsx';
import ScrollSpy from '../../components/ScrollSpy/ScrollSpy.jsx';
import ScrollSpyWatch from '../../components/ScrollSpy/ScrollSpyWatch.jsx';
import LinkScroll from '../../components/LinkScroll/LinkScroll.jsx';
import MenuCheum from '../../components/MenuCheum/MenuCheum.jsx';

import conf from '../../conf.js';
import scrollToElement from '../../services/scrollTo.js';

import './CGU.scss';

const title = "Conditions générales d'utilisation";
const description = `Les conditions générales d’utilisation et de vente sont conclues entre ${conf.site.name} et l'utilisateur`;

class CGU extends PureComponent {
  static iTopOffset = conf.topOffset;
  static sTopOffset = CGU.iTopOffset + 'px';

  componentDidMount() {
    scrollToElement(this.props.location.hash);
  }

  render() {
    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return <DefaultLayout className="cgu" helmet={helmet}>
      <ImageHeader>
        <ImageHeaderTitle>
          <h1>Conditions générales d'utilisation</h1>
        </ImageHeaderTitle>
      </ImageHeader>
      <section id="cgu-body">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="intro">
                <div className="mt-5">
                  <div className="mb-5">
                    <p>
                      Les présentes conditions générales d’utilisation et de vente (ci-après dénommées « CGU ») sont
                      conclues entre :<br/>
                      <strong>9472-6635 Québec Inc.</strong>, personne morale légalement
                      constituée, domicilié au {conf.address.street}, {conf.address.locality} {conf.address.postalCode},
                      représentée par Eric Betton dûment autorisé aux fins des présentes.<br/>
                      Ci-après dénommée « {conf.site.name.toUpperCase()} » d’une part<br/>
                      Et<br/>
                      L’Utilisateur du Site {conf.site.url.full}
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="general">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="general">Information générales</h2></div>
                  <div className="mb-5">
                    <p>
                      Contact courriel : {conf.site.emails.contact}<br/>
                      Numéro de téléphone : {conf.site.phone}<br/>
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="preambule">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="preambule">Préambule</h2></div>
                  <div className="mb-5">
                    <p>
                      La société exploite un site internet accessible à l’adresse {conf.site.url.full} proposant une
                      mise en relation entre des professionnels indépendants (ci-après « Consultants ou Consultants
                      freelances ») réalisant des prestations de conseil et des donneurs d’ordre/clients (ci-après
                      « Donneurs d’Ordre ») et collectivement les « Utilisateurs ».
                    </p>
                    <p>
                      Les présentes CGU ont pour objet de régir les conditions d’utilisation du Site ainsi que les
                      droits et obligations des Utilisateurs. Tout accès ou utilisation du Site suppose l’acceptation
                      sans réserve et le respect de l’ensemble des CGU. Bien que certaines parties des présentes CGU
                      puissent faire référence à d'autres entités, elles ne régissent que la relation entre
                      {conf.site.name.toUpperCase()} et l’Utilisateur et non entre l’Utilisateur et d’autres entités.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="registration">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="registration">Inscription au Site</h2></div>
                  <div className="mb-5">
                    <p>
                      Pour pouvoir accéder aux services proposés par le Site, l’Utilisateur doit créer un compte en
                      s’inscrivant gratuitement sur le Site. L’Utilisateur doit être âgé d’au moins 18 ans et avoir la
                      pleine capacité de contracter et d’utiliser le Site conformément aux présentes CGU. L’Utilisateur
                      est tenu de fournir des informations exactes qu’il s’engage à mettre à jour, sans délai, en cas de
                      modification.
                    </p>
                    <p>
                      L'Utilisateur devra en outre communiquer à la Société tout document relatif à son identification
                      ou à sa situation vis-à-vis des obligations légales en vigueur, le cas échéant, sur simple demande
                      de {conf.site.name.toUpperCase()} et ce, dans un délai de 48 heures.
                    </p>
                    <p>
                      L’accès au compte créé pour l’Utilisateur est protégé par un identifiant et un mot de passe.
                    </p>
                    <p>
                      L’Utilisateur est le seul responsable de tout usage qui sera fait de ces deux informations et il
                      est le seul garant de leur confidentialité. L’Utilisateur sera tenu comme seul responsable de
                      toute utilisation de son compte.
                    </p>
                    <p>
                      Dans l'hypothèse où l’Utilisateur fournirait des données fausses, inexactes, périmées ou
                      incomplètes, la Société sera en droit de suspendre ou de procéder à la fermeture de son compte et
                      de lui refuser, à l'avenir, l'accès à tout ou partie des Services.
                    </p>
                    <p>
                      La Société se réserve le droit de refuser toute inscription ou de mettre fin à toute utilisation
                      de compte d’Utilisateur sur simplement notification électronique et sans obligation de motivation.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="services">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="services">Description des Services et fonctionnement du Site</h2>
                  </div>
                  <div className="mb-5">
                    <p>
                      Une fois inscrit, l’Utilisateur peut bénéficier des Services du Site. Ces Services comprennent
                      notamment :
                    </p>
                    <ol type="a">
                      <li>
                        Une mise en relation entre les Consultants et les Donneurs d’Ordre par l’intermédiaire
                        de {conf.site.name.toUpperCase()};
                      </li>
                      <li>
                        Une mise à disposition d’outils pour évaluer les compétences des Consultants en vue d’informer
                        les Donneurs d’Ordre;
                      </li>
                      <li>
                        Des prestations de conseil pour assister les Donneurs d’Ordre dans la recherche de Consultants
                        pouvant remplir des missions identifiées.
                      </li>
                    </ol>
                    <p>
                      Les Consultants ayant remplis leur fiche de renseignement et ayant été acceptés après évaluation
                      de leur dossier par {conf.site.name.toUpperCase()} sont inscrits dans une base de données anonyme
                      accessible sur le Site. A noter que le tarif journalier indicatif et la disponibilité des
                      Consultants sont donnés sur le Site à titre purement indicatif et ne saurait être considérés comme
                      des engagements ou des obligations de la part des Utilisateurs ou {conf.site.name.toUpperCase()}.
                      En conséquence de quoi les Utilisateurs et {conf.site.name.toUpperCase()} se réservent le droit de
                      modifier ces éléments à tout moment sans que cela puisse donner lieu à un quelconque préjudice ni
                      à une quelconque réparation.
                    </p>
                    <p>
                      Les Donneurs d’Ordre peuvent ensuite utiliser les outils de recherche mis à disposition par le
                      Site pour identifier un ou plusieurs Consultants susceptibles d’effectuer une mission pour leur
                      compte. Les Donneurs d’Ordre sollicitent alors le Site ou {conf.site.name.toUpperCase()} pour
                      identifier les Consultants concernés et rentrer en relation avec eux.
                      {conf.site.name.toUpperCase()} se réserve le droit de donner suite ou non à cette demande.
                    </p>
                    <p>
                      Sous réserve d’engagement des différents Utilisateurs de respecter les conditions financières et
                      opérationnelles de la mise en relation proposées par {conf.site.name.toUpperCase()}, le Donneur
                      d’ordre, le consultant et la Société peuvent rentrer en contact en vue d’évoquer les conditions de
                      réalisation d’une mission. En cas d’aboutissement des discussions, {conf.site.name.toUpperCase()}
                      signe un contrat avec le consultant d’une part et un contrat avec le Donneur d’Ordre d’autre part
                      en vue de réaliser la mission.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="access">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="access">Accès au Site et aux Services</h2></div>
                  <div className="mb-5">
                    <p>
                      L’accès au Site et aux Services est exclusivement réservé aux Utilisateurs inscrits. Les
                      Utilisateurs font leur affaire personnelle de la mise en place des moyens permettant l’accès au
                      Site. Ils conservent à leur charge les frais de télécommunication lors de l’accès et de
                      l’utilisation du Site. Le Site est accessible 24 heures sur 24, 7 jours sur 7 pour l’ensemble des
                      Utilisateurs.
                    </p>
                    <p>
                      La Société se réserve le droit, sans préavis ni indemnité, de fermer temporairement ou
                      définitivement le Site ou l’accès à un ou plusieurs Services pour effectuer des mises à jour ou
                      des services de maintenance. Elle se réserve plus généralement le droit d’apporter au Site et aux
                      Services toutes les modifications et améliorations qu’elle jugera nécessaires ou utiles dans le
                      cadre du bon fonctionnement du Site et de ses Services.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="content-usage">
                <div className="mt-5 pt-5">
                  <div className="mb-5">
                    <h2 id="content-usage">Utilisation du contenu; restrictions; énoncé de confidentialité</h2>
                  </div>
                  <div className="mb-5">
                    <p>
                      Sauf indication contraire, et à condition de respecter toutes les obligations en vertu des
                      présentes conditions d’utilisation, l’Utilisateur est autorisé à visionner, à copier, à imprimer
                      et à distribuer (sans le modifier) le contenu du présent site web aux conditions suivantes :
                    </p>
                    <ol type="i">
                      <li>l’utilisation du contenu vise un but d’information seulement et n’a aucun but commercial;</li>
                      <li>
                        tout extrait du contenu doit être accompagné de l’avis relatif aux droits d’auteur ou autre
                        mention, s’il y a lieu, concernant le contenu.
                      </li>
                    </ol>
                    <p>
                      L’Utilisateur n’est pas autorisé à copier ni à utiliser les logiciels, les procédés exclusifs ou
                      les technologies intégrés dans le présent site web.
                    </p>
                    <p>
                      L’Utilisateur doit respecter toutes les lois applicables lors de la consultation et l’utilisation
                      du site web.
                    </p>
                    <p>L’Utilisateur reconnait que ses données et renseignements personnels peuvent être utilisés
                      conformément aux dispositions légales applicables.
                    </p>
                    <p>L’Utilisateur s’engage notamment à :</p>
                    <ol>
                      <li>
                        Satisfaire à toutes les obligations légales et réglementaires
                        <p>
                          L’Utilisateur, notamment lorsqu’il est consultant, s’engage à accomplir toutes les
                          déclarations et toutes les formalités nécessaires à son activité et à l’utilisation des
                          Services, en matière juridique, sociale, administrative et fiscale notamment. Sur simple
                          demande, l’Utilisateur s’engage à fournir tout document prouvant qu’il remplit toutes les
                          obligations énoncées ci-dessus.
                        </p>
                      </li>
                      <li>
                        S’interdire de contourner la mise en relation proposée par le Site. L’Utilisateur s’interdit :
                        <ol type="a">
                          <li>
                            de publier ou de communiquer toute information permettant à un autre Utilisateur du Site de
                            rentrer en contact directement avec lui sans passer par l’intermédiaire du Site ou de la
                            Société. Sont en particulier visé par cette disposition toute communication d’adresse
                            courriel ou de numéro de téléphone de nature à concrétiser un contact direct entre deux
                            Utilisateurs sans passer par l’intermédiaire du Site ou de la Société.
                          </li>
                          <li>
                            de contractualiser, à titre personnel ou par sa propre société, sans l'intermédiaire de la
                            Société avec un Client final pour le besoin du Client dont il aurait été mis en relation par
                            l'intermédiaire de la Société.
                          </li>
                        </ol>
                      </li>
                      <li>
                        Utiliser de bonne foi et de manière loyale le Site
                        <p>
                          L’Utilisateur s’interdit d’utiliser le contenu du site pour mettre en place toute action de
                          promotion commerciale pour son compte ou celui d’un tiers autre que pour les prestations de
                          conseils visées par le Site. L’Utilisateur s’interdit également de constituer des bases de
                          données commerciales à but de démarchage ou d’utiliser les informations collectées sur le site
                          en vue d’établir des études ou en vue de mener des actions de recrutement non autorisées par
                          la Société.
                        </p>
                        <p>
                          L’Utilisateur s’engage à garder une stricte confidentialité aux échanges qu’il aurait eu avec
                          des Clients/Donneurs d’Ordre et aux informations qui lui auraient été transmises ou dont il
                          aurait connaissance à l’occasion d’une mise en contact via le Site (ayant ou non donné lieu à
                          une Mission).
                        </p>
                        <p>
                          Sans préjudice de tout droit de résiliation ou de suspension du contrat, de demande de
                          dommages et intérêts, d'injonction ou de tout autre recours dont dispose
                          {conf.site.name.toUpperCase()} pour faire cesser toute violation, l'Utilisateur reconnait et
                          accepte qu'à défaut des se conformer aux présentes obligations, et notamment aux paragraphes
                          (2) et (3), il sera tenu de payer à {conf.site.name.toUpperCase()}, sur demande, à partir du
                          moment où il est en défaut, un montant de cinq mille dollars (5 000 $) à titre de pénalité,
                          le tout sans autre formalité ni préavis.
                        </p>
                      </li>
                    </ol>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="notation">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="notation">Système d’évaluation et de recommandation</h2></div>
                  <div className="mb-5">
                    <p>
                      {conf.site.name.toUpperCase()} appliquera son propre système d’évaluation sur la base du CV, des
                      références données par le Consultant et des entretiens de qualification qui pourraient avoir lieu,
                      l’objectif étant de standardiser les niveaux d’expertises dans les différents domaines en dehors
                      de toute appréciation personnelle.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="user-responsibility">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="user-responsibility">Responsabilité de l’Utilisateur</h2></div>
                  <div className="mb-5">
                    <p>
                      L’Utilisateur est seul responsable des informations et contenus qu’il diffuse par le biais du
                      Site, {conf.site.name.toUpperCase()} ne contrôlant pas ces éléments avant mise en ligne.
                      L’Utilisateur est seul responsable des conséquences et préjudices qui résulteraient de la
                      communication d’informations ou contenus inexactes ou trompeurs.
                    </p>
                    <p>
                      L’Utilisateur s’interdit également de publier tout contenus susceptibles de porter atteinte aux
                      droits, à la réputation et à l’image de {conf.site.name.toUpperCase()} et de son Site et d’une
                      manière générale tout contenu qui enfreindrait les lois et règlements en vigueur.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="company-responsibility">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="company-responsibility">Responsabilité de la Société</h2></div>
                  <div className="mb-5">
                    <p>
                      La Société réalise ses meilleurs efforts pour assurer l’accès et le fonctionnement du Site 24
                      heures sur 24, 7 jours sur 7. Toutefois, de par la nature du fonctionnement d’Internet, la Société
                      ne saurait exclure l’interruption ou le mauvais fonctionnement du Site et des Services. Aussi la
                      Société ne saurait être tenue pour responsable d’une quelconque interruption de Service,
                      volontaire ou non, et des conséquences potentielles pour les Utilisateurs.
                    </p>
                    <p>
                      La Société ne saurait être tenue pour responsables des informations erronées, inexactes ou
                      trompeuses publiées par des Utilisateurs sur le Site.
                    </p>
                    <p>
                      La Société fait tout son possible pour s’assurer du contenu et de la validité des informations sur
                      le Site, mais ne saurait en être tenue pour responsable.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="data">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="data">Données personnelles</h2></div>
                  <div className="mb-5">
                    <p>
                      Des données à caractère personnel de l’Utilisateur font l’objet d’un traitement informatisé par
                      {conf.site.name.toUpperCase()} destiné à assurer le bon fonctionnement du Site et des Services et
                      également à des fins statistiques et de prospection commerciale. TWINEEDS est seule destinataire
                      de ces données, les informations collectées ne sont ni revendues ni communiquées à des tiers.
                    </p>
                    <p>
                      Conformément aux dispositions légales, l’Utilisateur bénéficie d’un droit d’accès et de
                      rectification aux informations qui le concernent. Pour exercer ce droit et obtenir communication
                      des informations le concernant, l’Utilisateur peut contacter {conf.site.name.toUpperCase()} par
                      courrier adressé à son siège social ou par courriel. L’Utilisateur peut également s’opposer à ce
                      traitement pour des motifs légitimes. Cette opposition peut toutefois entrainer une fermeture du
                      compte de l’Utilisateur.
                    </p>
                    <p>
                      {conf.site.name.toUpperCase()} est destinataire des données à caractère personnel recueillies par
                      l’intermédiaire du Site. Elle s’engage à mettre tous les moyens en œuvre pour assurer la sécurité
                      et la confidentialité de ces données.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="cookies">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="cookies">Cookies</h2></div>
                  <div className="mb-5">
                    <p>
                      Lors de la consultation du Site, des informations relatives à la navigation de votre appareil
                      (ordinateur, tablette, mobile, etc.) sont susceptibles d’être enregistrées dans des fichiers
                      témoins « Cookies » présents sur l’appareil de l’Utilisateur sous réserve des choix exprimés par
                      ce dernier concernant ceux-ci.
                    </p>
                    <p>
                      Un Cookie est un fichier texte, qui a notamment pour but de collecter des informations relatives à
                      la navigation et à l’identification de l’Utilisateur.
                    </p>
                    <p>
                      La durée maximale de conservation des cookies implantés par {conf.site.name.toUpperCase()} est de
                      douze (12) mois. L’Utilisateur dispose toutefois de la possibilité de s’opposer à l’utilisation de
                      ces Cookies en configurant de manière appropriée son logiciel de navigation.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="prop-intellect-site">
                <div className="mt-5 pt-5">
                  <div className="mb-5">
                    <h2 id="prop-intellect-site">Propriété intellectuelle de {conf.site.name.toUpperCase()}</h2>
                  </div>
                  <div className="mb-5">
                    <p>
                      Le Site et chacun des éléments qui le composent constituent, ensemble, une œuvre protégée par les
                      lois en vigueur sur la propriété intellectuelle, dont {conf.site.name.toUpperCase()} est
                      titulaire. Aucune exploitation commerciale, reproduction, représentation, utilisation, adaptation,
                      modification, incorporation, traduction, commercialisation, partielle ou intégrale de ces éléments
                      ne pourra en être faite sans l'accord préalable et écrit de {conf.site.name.toUpperCase()}.
                    </p>
                    <p>
                      Toute représentation, reproduction ou adaptation des logos, contenus textuels, pictographiques ou
                      vidéos, sans que cette énumération ne soit limitative, est rigoureusement interdite et s’apparente
                      à de la contrefaçon.
                    </p>
                    <p>
                      Tout Utilisateur qui se rendrait coupable de contrefaçon serait susceptible de voir son accès au
                      site supprimé sans préavis ni indemnité et sans que cette exclusion ne puisse lui être
                      constitutive d’un dommage, sans réserve d’éventuelles poursuites judiciaires ultérieures à son
                      encontre, à l’initiative de {conf.site.name.toUpperCase()}.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="prop-intellect-content">
                <div className="mt-5 pt-5">
                  <div className="mb-5">
                    <h2 id="prop-intellect-content">Propriété intellectuelle des contenus publiés par l’Utilisateur</h2>
                  </div>
                  <div className="mb-5">
                    <p>
                      Tout Utilisateur qui publie des éléments de contenu (texte, images, commentaires …) sur le Site
                      conserve l’entière propriété de tout ce qu’il publie.
                    </p>
                    <p>
                      En communiquant des contenus par le biais du Site, l’Utilisateur autorise
                      expressément {conf.site.name.toUpperCase()} à utiliser, diffuser, héberger, stocker, reproduire,
                      communiquer, publier, modifier, adapter, traduire et afficher tout ou partie du Contenu sur le
                      Site, les réseaux sociaux ou sur tous autres supports, par tous moyens, à des fins d’exploitation,
                      d’amélioration, de promotion, de marketing, de publicité des Services et du Site ou pour les
                      besoins de la mise en place de partenariats. Cette autorisation est valable pour le monde entier
                      et pour toute la durée de l’inscription de l’Utilisateur.
                    </p>
                    <p>
                      L’Utilisateur reconnaît que toute utilisation de son contenu effectuée
                      par {conf.site.name.toUpperCase()} préalablement à sa désinscription, la suppression ou la
                      résiliation de son compte ne pourra pas être remise en cause.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="duration">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="duration">Durée, résiliation et sanctions</h2></div>
                  <div className="mb-5">
                    <p>
                      Les présentes CGU sont applicables pour une durée indéterminée à compter de l’acceptation de
                      l’acceptation de celles-ci par l’Utilisateur.
                    </p>
                    <p>
                      Dans le cas où l’Utilisateur ne respecterait pas tout ou partie des CGU ou plus largement les lois
                      et règlements en vigueur, {conf.site.name.toUpperCase()} se réserve le droit de suspendre ou de
                      fermer le compte de l’Utilisateur immédiatement, sans préjudice de tous les dommages et intérêts
                      éventuels que {conf.site.name.toUpperCase()} pourrait réclamer.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="nullite">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="nullite">Divisibilité – Renonciation</h2></div>
                  <div className="mb-5">
                    <p>
                      Si toute partie des présentes devait être considérée comme invalide ou inexécutable, alors cette
                      partie n’affectera pas la validité ou l’application des CGU, qui sera alors exécutée, et cette
                      partie invalide ou inapplicable devra être séparée des CGU.
                    </p>
                    <p>
                      Le défaut pour la Société d’exercer les droits qui lui sont reconnus en application des présentes
                      ne constitue pas une renonciation à faire valoir ses droits.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="modifs">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="modifs">Modification</h2></div>
                  <div className="mb-5">
                    <p>
                      {conf.site.name.toUpperCase()} se réserve le droit de modifier tout ou partie des présentes CGU.
                      En cas de modification, {conf.site.name.toUpperCase()} informera les Utilisateurs par tout moyen à
                      sa disposition.
                    </p>
                    <p>
                      L’Utilisateur disposera d’un délai de 48h à compter de la date de notification pour faire part de
                      son éventuel désaccord quant aux nouvelles dispositions des CGU par tout moyen. À défaut de
                      notification du désaccord dans les délais précisés ci-dessus, l’Utilisateur sera réputé avoir
                      accepté les modifications apportées aux CGU.
                    </p>
                  </div>
                </div>
              </ScrollSpy>

              <ScrollSpy topOffset={CGU.sTopOffset} group="cgu" name="rights">
                <div className="mt-5 pt-5">
                  <div className="mb-5"><h2 id="rights">Droit applicable et juridiction compétence</h2></div>
                  <div className="mb-5">
                    <p>
                      Les présentes CGU sont régies par les lois de la province de Québec et les lois du Canada, sans
                      égard aux principes de conflit de lois. L’Utilisateur reconnait par les présentes que tout litige
                      découlant de son utilisation du Site ou à l’application, l’exécution ou l’interprétation des CGU,
                      sera soumis à la compétence des tribunaux du district de Montréal, province de Québec.
                    </p>
                  </div>
                </div>
              </ScrollSpy>
            </div>

            <div className="col-lg-3 d-lg-block d-none">
              <MenuCheum className="cheum-cgu">
                <ScrollSpyWatch group="cgu" name="general">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#general">Information générales</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="preambule">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#preambule">Préambule</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="registration">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#registration">Inscription au Site</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="services">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#services">
                    Description des Services et fonctionnement du Site
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="access">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#access">Accès au Site et aux Services</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="content-usage">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#content-usage">
                    Utilisation du contenu; restrictions; énoncé de confidentialité
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="notation">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#notation">
                    Système d’évaluation et de recommandation
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="user-responsibility">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#user-responsibility">
                    Responsabilité de l’Utilisateur
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="company-responsibility">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#company-responsibility">
                    Responsabilité de la Société
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="data">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#data">Données personnelles</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="cookies">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#cookies">Cookies</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="prop-intellect-site">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#prop-intellect-site">
                    Propriété intellectuelle de {conf.site.name.toUpperCase()}
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="prop-intellect-content">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#prop-intellect-content">
                    Propriété intellectuelle des contenus publiés par l’Utilisateur
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="duration">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#duration">
                    Durée, résiliation et sanctions
                  </LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="nullite">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#nullite">Divisilité – Renonciation</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="modifs">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#modifs">Modification</LinkScroll>
                </ScrollSpyWatch>
                <ScrollSpyWatch group="cgu" name="rights">
                  <LinkScroll offsetTop={CGU.iTopOffset} to="#rights">
                    Droit applicable et juridiction compétence
                  </LinkScroll>
                </ScrollSpyWatch>
              </MenuCheum>
            </div>
          </div>
        </div>
      </section>
    </DefaultLayout>;
  }
}

export default withRouter(CGU);